export const API_URL = 'https://www.cooperativa-cocrafi.com.br/api';